module.exports = __webpack_public_path__ + "static/media/Truemoney_vertical.7b77c05b.svg";